<template>
    <div class="alert-box-container">
        <div class="alert-box" :class="{'centered': mergedConfig.centered}" :style="{width: width}">

            <div class="alert-icon" :class="mergedConfig.type">
                <span :class="'taxi-' + mergedConfig.type"></span>
            </div>

            <div class="alert-content">
                {{content}}
            </div>

            <div class="alert-actions">
                <template v-if="mergedConfig.actionHandler">
                    <button @click="mergedConfig.actionHandler" class="button secondary small">{{mergedConfig.confirmButtonText}}</button>
                    <button @click="closeAlert" class="button primary small">{{mergedConfig.cancelButtonText}}</button>
                </template>
                <template v-if="mergedConfig.actionHandlers && Array.isArray(mergedConfig.actionHandlers)">
                    <button v-for="actionHandler in mergedConfig.actionHandlers"
                            @click="runHandler(actionHandler.handler)"
                            class="button small"
                            :class="actionHandler.buttonClass">
                        {{actionHandler.buttonText}}
                    </button>
                </template>
                <template v-else>
                    <button @click="closeAlert" class="button primary small">დახურვა</button>
                </template>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        props:{
            width: {
                type: String,
                default: '90%'
            },
            config: {
                type: Object,
                default: null
            },
            content: String
        },
        data(){
            return{
                defaultConfig:{
                    centered: true,
                    type: 'success',
                    actionHandler: null,
                    confirmButtonText: 'დიახ',
                    cancelButtonText: 'არა'
                }
            }
        },
        methods:{
            closeAlert(){
                this.$emit('close')
            },
            runHandler(handler){
                handler();
                this.closeAlert();
            }
        },
        computed: {
            mergedConfig(){
                return this.config ? Object.assign({}, this.defaultConfig, this.config) : this.defaultConfig;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .alert-box-container{
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .3);
        z-index: 9999;

        .alert-box {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateY(-50%) translateX(-50%);
            display: flex;
            flex-direction: column;
            background-color: $white;
            padding: 20px;
            border-radius: $border-radius;
            box-shadow: $box-shadow;

            &.centered{
                align-items: center;
                .alert-content, .alert-actions{
                    justify-content: center;
                    text-align: center;
                }
            }

            .alert-icon{
                font-size: 1.8rem;

                &.success {
                    color: $success-color
                }
                &.error {
                    color: $danger-color;
                }
                &.warning {
                    color: $warning-color;
                }
            }

            .alert-content {
                display: flex;
                margin-top: 10px;
                font-size: .85rem;
            }

            .alert-actions {
                display: flex;
                margin-top: 20px;

                button:last-child {
                    margin-left: 20px;
                }
            }
        }
    }
</style>